'use client'
import { Authentication } from "@/components/AuthenticationLink"
import { DiscoverCard, DiscoverSkeletonCard } from "@/components/DiscoverCard"
import { ScrollLoadList } from "@/components/ScrollLoadList"
import { useScrollElementContext } from "@/provider/ScrollElementProvider"
import { resizeImage } from "@/util/image"
import { useToChat } from "../../(other)/robot/[id]/_components/RobotDetailAside/ToChatButton"
import { useState } from "react"
import GlobalLoading from "@/components/GlobalLoading"
import { Image } from "@heroui/react"

export const RobotList = ({
  data,
  isFetching,
  fetchNextPage,
  hasNextPage
}) => {

  const { container: scrollCotnainer } = useScrollElementContext()

  const toChat = useToChat()

  const [avatar, setAvatar] = useState("")
  // 移动端同一时间只展开一个卡片的问候语，点开新卡片自动收起其他
  const [activeId, setActiveId] = useState<number | string | null>(null)

  return (
    <>
      {toChat.isPending && <GlobalLoading >
        <Image radius="full" classNames={{ wrapper: "w-[100px] h-[100px] animate__animated tada", img: "w-[100px] h-[100px]" }} src={resizeImage(avatar, 200)} />
      </GlobalLoading>}
      <ScrollLoadList
        className="grid-card-list mt-4 sm:mt-5"
        data={data}
        isFetching={isFetching}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        scrollCotnainer={scrollCotnainer}
        skeleton={<DiscoverSkeletonCard />}
      >
        {(item) => (
          <Authentication
            key={item.robots_id}
            render={verify => (
              <DiscoverCard
                robotId={item.robots_id}
                avatar={item.avatar}
                backgroundImage={item.background_image}
                isBackgroundImage={item.is_background_image}
              name={item.robot_name}
              desc={item.scene}
              greeting={item.greeting}
              comments={item.chat_num}
              likes={item.upvote_count}
              author={item.user_name || item.username}
              authorAvatar={item.user_avatar}
              categories={item.categories}
              mobileActive={activeId === item.robots_id}
              onMobileActivate={setActiveId}
              onChat={() => {
                  if (verify()) {
                    setAvatar(item.avatar)
                    toChat.onPressChat(item.robots_id)
                  }
                }}
              />
            )} />

        )}
      </ScrollLoadList>
    </>

  )
}